import { Component } from '@angular/core';
import {StatisticService} from "../statistic.service";
import {HttpResponse} from "@angular/common/http";
import {Button} from "primeng/button";
import {CalendarModule} from "primeng/calendar";
import {NgForOf, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {MessagesModule} from "primeng/messages";

export interface BookingPaymentStatistic {
  bookingCount: number;
  total: number | null;
  totalHS: number | null;

  medianTotal: number | null;
  medianHS: number | null;
  averageTotal: number | null;
  averageHS: number | null;

  medianDuration: number | null;
  averageDuration: number | null;

  spendingReason: Map<BookingPriceType, number>;
}

enum BookingPriceType {
  PROMO_CODE,
  EXTRA_HOURLY_BASE,
  CAB,
  MIN_DURATION,
  SURGE_PRICE,
  TIP_FEE,
  TAXI_FEE,
  ADDITIONAL_EXPENSE,
  CANCELLATION,
  UNKNOWN
}

@Component({
  selector: 'app-money',
  standalone: true,
  imports: [
    Button,
    CalendarModule,
    NgForOf,
    NgIf,
    FormsModule,
    MessagesModule
  ],
  templateUrl: './money.component.html',
})
export class Money {
  statistic?: BookingPaymentStatistic
  from: Date = new Date()
  to: Date = new Date()
  array: Array<[string, any]> = [];
  loading = false;
  errorMessage?: any[]

  spendingReasons: any

  constructor(private statisticService: StatisticService) {
  }

  load() {
    this.loading = true;
    this.errorMessage = undefined
    this.statisticService.findPaymentStatistic(this.from, this.to).subscribe(
      {
        next: (response: HttpResponse<BookingPaymentStatistic>) => {
          this.statistic = response.body ? response.body : undefined;
          if (!this.statistic) return
          this.spendingReasons = [...new Map(Object.entries(this.statistic.spendingReason)).entries()]

          this.array = [];
          this.array.push(['Booking count', this.statistic.bookingCount])
          this.array.push(['Total amount', '$' + this.statistic.total])
          this.array.push(['Total amount HS','$' + this.statistic.totalHS])
          this.array.push(['Median amount', '$' + this.statistic.medianTotal])
          this.array.push(['Median amount HS', '$' + this.statistic.medianHS])
          this.array.push(['Average amount', '$' + this.statistic.averageTotal])
          this.array.push(['Average amount HS', '$' + this.statistic.averageHS])
          this.array.push(['Median duration', this.statistic.medianDuration + 'h'])
          this.array.push(['Average duration', this.statistic.averageDuration + 'h'])
        },
        error: (error: any) => {
          console.error(error);
          if (error.status === 0) {
            this.errorMessage = [{ severity: 'error', detail: 'Server not responding' }];
          } else {
            this.errorMessage = [{ severity: 'error', detail: error.detail }];
          }
          this.loading = false
        },
        complete: () => this.loading = false
      }
    )
  }

}
